(function () {
  function formatMoney(cents) {
    var sign = cents < 0 ? '-' : '+';
    var abs = Math.abs(cents);
    var dollars = abs / 100;
    return sign + '$' + dollars.toFixed(2).replace(/\.00$/, '');
  }

  function ensureTooltip(picker) {
    var deltaEl = picker.querySelector('[data-kw-variant-delta]');
    if (!deltaEl) {
      deltaEl = document.createElement('div');
      deltaEl.className = 'kw-variant-delta';
      deltaEl.setAttribute('data-kw-variant-delta', '');
      deltaEl.hidden = true;
      picker.appendChild(deltaEl);
    }
    return deltaEl;
  }

  function getVariants(picker) {
    var s = picker.querySelector('script[data-kw-variants]');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function getCurrentOptions(picker) {
    var opts = [];
    picker.querySelectorAll('fieldset.product-form__input').forEach(function (fs) {
      var checked = fs.querySelector('input[type="radio"]:checked');
      opts.push(checked ? checked.value : null);
    });
    picker.querySelectorAll('.product-form__input--dropdown select').forEach(function (sel) {
      opts.push(sel.value);
    });
    return opts;
  }

  function findVariant(variants, optionValues) {
    return variants.find(function (v) {
      for (var i = 0; i < optionValues.length; i++) {
        if (v.options[i] !== optionValues[i]) return false;
      }
      return true;
    });
  }

  function indexOfPicker(picker, el) {
    var fs = el.closest('fieldset.product-form__input');
    if (fs) {
      var fsList = Array.prototype.slice.call(picker.querySelectorAll('fieldset.product-form__input'));
      return fsList.indexOf(fs);
    }
    var dd = el.closest('.product-form__input--dropdown');
    if (dd) {
      var fsCount = picker.querySelectorAll('fieldset.product-form__input').length;
      var ddList = Array.prototype.slice.call(picker.querySelectorAll('.product-form__input--dropdown'));
      return fsCount + ddList.indexOf(dd);
    }
    return -1;
  }

  function showDelta(picker, targetValue, pickerIndex, anchorEl) {
    var variants = getVariants(picker);
    if (!variants) return;
    var deltaEl = ensureTooltip(picker);
    var current = getCurrentOptions(picker);
    var currentVariant = findVariant(variants, current);
    if (!currentVariant) return;
    var hoverOpts = current.slice();
    hoverOpts[pickerIndex] = targetValue;
    var hoverVariant = findVariant(variants, hoverOpts);
    if (!hoverVariant) {
      deltaEl.textContent = 'Unavailable combination';
      deltaEl.dataset.kind = 'unavailable';
    } else if (hoverVariant.id === currentVariant.id) {
      deltaEl.hidden = true;
      return;
    } else {
      var diff = hoverVariant.price - currentVariant.price;
      if (diff === 0) {
        deltaEl.textContent = 'Same price';
        deltaEl.dataset.kind = 'same';
      } else {
        deltaEl.textContent = formatMoney(diff);
        deltaEl.dataset.kind = diff > 0 ? 'up' : 'down';
      }
    }
    var rect = anchorEl.getBoundingClientRect();
    var pickerRect = picker.getBoundingClientRect();
    deltaEl.style.left = (rect.left - pickerRect.left + rect.width / 2) + 'px';
    deltaEl.style.top = (rect.bottom - pickerRect.top + 8) + 'px';
    deltaEl.hidden = false;
  }

  function hide(picker) {
    var deltaEl = picker.querySelector('[data-kw-variant-delta]');
    if (deltaEl) deltaEl.hidden = true;
  }

  function matchInput(t) {
    if (!t) return null;
    return t.closest('input[type="radio"][data-option-value-id], input.swatch-input__input, label[for]');
  }

  function setup(picker) {
    if (picker.dataset.kwDeltaBound === '1') return;
    picker.dataset.kwDeltaBound = '1';

    picker.addEventListener('mouseover', function (e) {
      var anchor = matchInput(e.target);
      if (!anchor) return;
      var input = anchor.tagName === 'LABEL'
        ? picker.querySelector('#' + CSS.escape(anchor.getAttribute('for')))
        : anchor;
      if (!input) return;
      var idx = indexOfPicker(picker, input);
      if (idx < 0) return;
      showDelta(picker, input.value, idx, anchor);
    });

    picker.addEventListener('mouseout', function (e) {
      if (!matchInput(e.target)) return;
      hide(picker);
    });

    picker.addEventListener('mousemove', function (e) {
      if (e.target.tagName !== 'OPTION') return;
      var sel = e.target.closest('select');
      if (!sel) return;
      var idx = indexOfPicker(picker, sel);
      if (idx < 0) return;
      showDelta(picker, e.target.value, idx, sel);
    });
  }

  function init() {
    document.querySelectorAll('variant-selects').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind after Shopify section refresh swaps variant-selects children.
  document.addEventListener('shopify:section:load', init);
  // Mutation observer covers Dawn's internal innerHTML swap when a variant changes.
  var observer = new MutationObserver(function () { init(); });
  observer.observe(document.body, { childList: true, subtree: true });
})();
